import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchWorkingModeShift = createAsyncThunk(
    'getAllWorkingModeShift/fetchWorkingModeShift',
    async (_, { rejectWithValue }) => {
        try {
            const url = api.credentials.workingModeShift;
            const response = await axiosPrivate.get(url)
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    }
)

const workingModeShiftSlice = createSlice({
    name: 'workingModeShift',
    initialState: {
        workingModeShift: {},
        status: 'idle',
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builders) => {
        builders
            .addCase(fetchWorkingModeShift.pending,
                (state) => {
                    state.status = 'loading';
                    state.loading = true;
                    state.error = null;
                })
            .addCase(fetchWorkingModeShift.fulfilled,
                (state, action) => {
                    state.status = 'succeeded';
                    state.loading = false;
                    // Helper to clean individual strings
                    const clean = (str) => str
                        .replace(/_/g, ' ')
                        .replace(/[^a-zA-Z0-9 ]/g, '')
                        .replace(/\s+/g, ' ')
                        .trim()
                        .toLowerCase()
                        .split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');


                    const data = action.payload;

                    // Clean both arrays inside the object
                    state.workingModeShift = {
                        ShiftType: (data?.ShiftType || []).map(item => clean(item)),
                        WorkingMode: (data?.WorkingMode || []).map(item => clean(item))
                    };
                })
            .addCase(fetchWorkingModeShift.rejected,
                (state, action) => {
                    state.status = 'failed';
                    state.loading = false;
                    state.error = action.payload;
                }
            )
    }
})

export default workingModeShiftSlice.reducer;